module.exports = __webpack_public_path__ + "static/media/599.756 (2).5015b6e0.pdf";